import _curry2 from './private/curry2.js';
import _isNumber from './private/isNumber.js';
const range = _curry2( (from, to) => {
  	if (!(_isNumber(from) && _isNumber(to))) {
        throw new TypeError('Both arguments to range must be numbers');
  	}
  	let result = [];
  	let n = from;
  	while (n <= to) {
	    result.push(n);
	    n += 1;
  	}
  	return result;
});
export default range;


// WEBPACK FOOTER //
// ./src/common/bare-metal/range.js